<template>
  <div>
    <b-navbar toggleable="md" type="dark" variant="danger">
      <b-navbar-brand href="#">Fundraising Team Suggestions</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item v-for="routes in links" v-bind:key="routes.id" :to="`${routes.page}`" :class="[currentPage == routes.page ? 'active' : '' , 'nav-link']">{{routes.text}}</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
  computed: {
    currentPage () {
      return this.$route.path
    }
  },
  data () {
    return {
      activeClass: 'active',

      links: [
        {
          id: 0,
          text: 'Add Suggestion',
          page: '/'
        },
        {
          id: 1,
          text: 'Read Responses',
          page: '/responses'
        },
        // {
        //   id: 2,
        //   text: 'Managers config',
        //   page: '/managers'
        // }
      ]
    }
  }
}
</script>

<style>
</style>
